export const waitingQueueKeys = {
  queueStatus: ["queueStatus"] as const,
};
